import { getCookie } from '@/shared/utils/cookie';

const DISCOUNT_NOTIFICATION_SHOW_DELAY = 500;
const DISCOUNT_NOTIFICATION_HIDE_DELAY = 4000;
// Matches the Tailwind `duration-500` transition on #js-discount-notification.
const DISCOUNT_NOTIFICATION_FADE_DURATION = 500;
const NOTIFICATION_CONTENT_SELECTOR = '[data-notification-content]';

export const showDiscountNotification = () => {
  const discountCodeCookie = getCookie('discount_code');
  if (!discountCodeCookie) {
    return;
  }

  const notificationKey = `discountNotificationShown_${discountCodeCookie}`;
  if (sessionStorage.getItem(notificationKey)) {
    return;
  }

  const notification = document.querySelector<HTMLDivElement>(
    '#js-discount-notification'
  );

  if (!notification) {
    console.warn('Discount notification element not found');
    return;
  }

  const content = notification.querySelector<HTMLDivElement>(
    NOTIFICATION_CONTENT_SELECTOR
  );
  const notificationText = notification.dataset.notificationText ?? '';

  if (!content || !notificationText) {
    console.warn('Discount notification content element not found');
    return;
  }

  sessionStorage.setItem(notificationKey, 'true');

  setTimeout((): void => {
    // Assigning text here (rather than rendering it from Liquid) counts as an
    // update to the role="status" live region, so screen readers announce it.
    content.textContent = notificationText;
    notification.classList.remove(
      'opacity-0',
      '-translate-y-20',
      'pointer-events-none'
    );
    notification.classList.add('opacity-100', 'translate-y-4');
  }, DISCOUNT_NOTIFICATION_SHOW_DELAY);

  setTimeout((): void => {
    notification.classList.remove('opacity-100', 'translate-y-4');
    notification.classList.add(
      'opacity-0',
      '-translate-y-20',
      'pointer-events-none'
    );
    // Wait for the fade to finish before emptying the box so the message
    // doesn't vanish mid-animation (leaving an empty pill sliding away).
    setTimeout((): void => {
      content.textContent = '';
    }, DISCOUNT_NOTIFICATION_FADE_DURATION);
  }, DISCOUNT_NOTIFICATION_SHOW_DELAY + DISCOUNT_NOTIFICATION_HIDE_DELAY);
};
